import Embedded from "@/Layouts/Embedded";
import {Head, Link, useForm, usePage} from "@inertiajs/inertia-react";
import ProductLogo from "@/Components/ProductLogo";
import React, {Fragment, useState} from "react";
import styles from '@/../sass/embedded/components/LoginCode.module.scss'
import {FormInput} from "@/Components/Controls";
import i18n from "i18next";
import Button from "@/Components/Button";
import AbstractLoginArtwork from "@/Components/AbstractLoginArtwork";

export default function LoginCode() {
    const organization = usePage().props.organization;

    const {data, setData} = useForm({
        code: '', mobileNumber: usePage().props.mobileNumber,
    });

    const [state, setState] = useState({
        mobileNumberObfuscated: usePage().props.mobileNumberObfuscated, processing: false, errors: []
    });

    const onChange = (name, value) => {
        setData(name, value);
    };

    const submit = (e) => {
        e.preventDefault();

        setState({...state, processing: true})
        axios.post(route('embedded.login.code.validate', organization.uuid), data).then((response) => {
            window.parent.postMessage(JSON.stringify(response.data.data), '*')
        }).catch((error) => {
            setState({...state, errors: error?.response?.data?.errors, processing: false});
        })
    };

    return (<Embedded>
            <Head>
                <title>{i18n.t("login.login-code")}</title>
            </Head>
            <AbstractLoginArtwork/>
            <div className={"login"}>
                <ProductLogo />
                <form onSubmit={submit}>
                    <Fragment>
                        <div
                            className={styles.instructions}>{i18n.t("login.enter-code")}<br/>{state.mobileNumberObfuscated}
                        </div>
                        <div className="row">
                            <FormInput error={state.errors["code"]}
                                       name="code"
                                       isFocused={true}
                                       value={data.code}
                                       onChange={onChange}
                                       label={i18n.t("login.login-code")}
                                       className="col-12"
                                       dataQa="login-tab-login-code"/>
                        </div>
                        <div className="">
                            <Button className="w-100 btn btn-primary" processing={state.processing}
                                    opacityWhileProcessing={false}>
                                {state.processing && <Fragment>
                                    <span className="spinner-border spinner-border-sm" role="status"
                                          aria-hidden="true"></span>
                                    <span className="visually-hidden">Loading...</span>
                                </Fragment>}
                                {!state.processing && i18n.t("login.log-in")}
                            </Button>
                        </div>
                    </Fragment>
                    <div className={styles.actions + " text-center"}>
                        <Link
                            href={route('embedded.login.show', organization.uuid)}
                            className="btn btn-link"
                        >
                            {i18n.t("login.back-to-login")}
                        </Link>
                    </div>
                </form>
            </div>
        </Embedded>)
}
